export const FETCH_ORGANIZATION_ROLES = 'fetchOrganizationRoles'; // eslint-disable-line import/prefer-default-export
